var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_menu"},[_c('Header'),(_vm.$store.state.flash_message)?_c('Flash'):_vm._e(),_c('div',{attrs:{"id":"router-view-frame"}},[_c('router-view'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }